import { Input, ElementRef, Directive } from '@angular/core';
import { IHRBMicroUiConfig } from '../interfaces/hrblock-micro-ui-config-interface';
import { DataService } from '../services/data.service';

/**
 * Manager for loading and unloading of Micro Elements
 */
@Directive()
export class HRBMicroUIAppManager {
    /**
     * Setting value for pConfig
     * @param  any pConfig
     */
    /**
    * Getting value of pConfig
    */
    @Input() public config: IHRBMicroUiConfig;
    /**
     * Micro application names and source paths.
     */
    /** Creates an instance of HRBMicroUIAppManager */
    constructor(private pConfig: IHRBMicroUiConfig, private dataService: DataService){
        pConfig = this.config;
     };
    /**
     * Load micro application.
     * @param  any containerRef
     */
    public load(containerRef: ElementRef): void {
        // add script tag
        if (!document.getElementById(this.pConfig.name)) {
            console.log("app-manager:load ... " + this.pConfig.name);
            const script = document.createElement('script');
            script.src = this.pConfig.path + '?v='+new Date().getTime();
            script.id = this.pConfig.name;
            document.body.appendChild(script);
        }

        // add web component
        let component = document.createElement(this.pConfig.name);
        component = this.dataService.getComponentInfo(component, this.pConfig.name);
        containerRef.nativeElement.appendChild(component);

        console.log("app-manager:loaded --> " + this.pConfig.name);
    };

    public delete(containerRef: ElementRef) : void {
        containerRef.nativeElement.remove();
        const script = document.getElementById(this.pConfig.name)
        script.remove();
    }

    /**
     * Remove element from the DOM.
     * @param  any containerRef
     * @returns void
     */
    remove(containerRef: ElementRef): void {
        // remove web component
        containerRef.nativeElement.remove()
    };
}
